import React from "react"
import Image from "../image"

class FlowIntroduction extends React.Component {
  render() {
    return (
      <div className="flow-introduction">
        <div className="container is-slim">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2">申し込みから導入までの流れ</h2>
          </div>
          <div>
            <ul className="steps is-vertical">
              <li className="steps-segment">
                <span className="steps-marker">1</span>
                <div data-aos="fade-up" className="steps-content">
                  <div className="columns">
                    <div className="column">
                      <div className="title">WEB申し込み</div>
                      <div>
                        5〜10分程度でお申し込みが終わります。WEB申し込みフォームから、店舗情報を正しくご入力ください。
                      </div>
                    </div>
                    <div className="column">
                      <Image filename="PicksforPartners/flow-introduction-1.png" />
                    </div>
                  </div>
                </div>
              </li>
              <li className="steps-segment">
                <span className="steps-marker">2</span>
                <div data-aos="fade-up" className="steps-content">
                  <div className="columns">
                    <div className="column">
                      <div className="title">最短2日で審査完了</div>
                      <div>
                        審査結果をメールでお知らせします。
                        <br />
                        お申込み内容が不十分の場合、メールで追加情報をいただくことがあります。
                      </div>
                    </div>
                    <div className="column">
                      <Image filename="PicksforPartners/flow-introduction-2.png" />
                    </div>
                  </div>
                </div>
              </li>
              <li className="steps-segment">
                <span className="steps-marker">3</span>
                <div data-aos="fade-up" className="steps-content">
                  <div className="columns">
                    <div className="column">
                      <div className="title">メニュー登録</div>
                      <div>
                        審査通過メールに記載された手順に沿って、Picksのアプリにログインします。メニューの登録を行っていただきます。
                      </div>
                    </div>
                    <div className="column">
                      <Image filename="PicksforPartners/flow-introduction-3.png" />
                    </div>
                  </div>
                </div>
              </li>
              <li className="steps-segment">
                <span className="steps-marker">4</span>
                <div data-aos="fade-up" className="steps-content">
                  <div className="columns">
                    <div className="column">
                      <div className="title">キット配送</div>
                      <div>
                        Picksの説明書や店舗用ステッカーが入った加盟店さま限定キットをお届けします。
                      </div>
                    </div>
                    <div className="column">
                      <Image filename="PicksforPartners/flow-introduction-4.png" />
                    </div>
                  </div>
                </div>
              </li>
              <li className="steps-segment">
                <span className="steps-marker">5</span>
                <div data-aos="fade-up" className="steps-content">
                  <div className="columns">
                    <div className="column">
                      <div className="title">Picksでの注文受け付け開始</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default FlowIntroduction
